export default {
  state: {
    orders: [],
    order: {},
    wishlistProducts: [],
    addressList: [],
    cardList: [],
    affiliate: null,
    affiliateBalance: null,
    affiliateTransactions: null,
  },
  getters: {
    getOrders: (state) => state.orders,
    getOrder: (state) => state.order,
    getWishlistProducts: (state) => state.wishlistProducts,
    getAddressList: (state) => state.addressList,
    getCardList: (state) => state.cardList,
    getAffiliate: (state) => state.affiliate,
    getAffiliateBalance: (state) => state.affiliateBalance,
    getAffiliateTransactions: (state) => state.affiliateTransactions,
  },
  mutations: {
    SET_ORDERS: (state, value) => (state.orders = value),
    SET_ORDER: (state, value) => (state.order = value),
    SET_WISHLIST_PRODUCTS: (state, value) => (state.wishlistProducts = value),
    SET_ADDRESS_LIST: (state, value) => (state.addressList = value),
    SET_CARD_LIST: (state, value) => (state.cardList = value),
    SET_AFFILIATE: (state, value) => (state.affiliate = value),
    SET_AFFILIATE_BALANCE: (state, value) => (state.affiliateBalance = value),
    SET_AFFILIATE_TRANSACTIONS: (state, value) =>
      (state.affiliateTransactions = value),
    APPEND_AFFILIATE_TRANSACTIONS: (state, tr) => {
      const prev = state.affiliateTransactions;
      state.affiliateTransactions = {
        data: [...((prev && prev.data) || []), ...((tr && tr.data) || [])],
        current_page: tr.current_page,
        last_page: tr.last_page,
        total: tr.total,
      };
    },
  },
  actions: {
    async searchOrders({ commit }, params) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${window.$platform || window.$getCookie("platform")}/order/list`,
            { ...params }
          );

        commit("SET_ORDERS", response.data);
      } catch (error) {
        console.log("[searchOrders]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async searchOrder({ commit }, data) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${window.$platform || window.$getCookie("platform")}/order/get`,
            { id: data }
          );

        commit("SET_ORDER", response.data);
      } catch (error) {
        console.log("[searchOrders]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async searchWishlistProducts({ commit }, userId) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/wishlist/get`,
            {
              all: true,
              customer_id: +userId,
            }
          );

        commit("SET_WISHLIST_PRODUCTS", response.data);
      } catch (error) {
        console.log("[searchOrders]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async removeWishlist({ commit, dispatch }, data) {
      try {
        commit("SET_LOADING", true);

        await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/wishlist/remove`,
            {
              id: data.id,
              customer_id: data.userId,
            }
          );

        await dispatch("searchWishlistProducts", data.userId);
      } catch (error) {
        console.log("[searchOrders]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async searchAddressList({ commit }, data) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/address/list`,
            { customer: { ...data } }
          );

        commit("SET_ADDRESS_LIST", response.data);
      } catch (error) {
        console.log("[searchAddressList]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createOrUpdateAddress({ commit }, { data, done, fail }) {
      try {
        commit("SET_LOADING", true);

        const cartId = window.$getCookie("cart-id");

        if (!data.complement) data.complement = "";
        if (!data.receiver) data.receiver = "";

        const response = await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/address/create`,
            { address: { ...data }, cartId }
          );

        commit("SET_ADDRESS_LIST", response.data);

        window.$toast({
          color: "success",
          message: "Endereço criado com sucesso!",
        });

        done(response.data);
      } catch (error) {
        console.log("[createOrUpdateAddress]", error);

        window.$toast({
          color: "error",
          message:
            "Tivemos um problema, tente novamente ou entre em contato conosco.",
        });
        fail(error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async removeAddress({ commit }, data) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/address/remove`,
            { address: { ...data } }
          );

        commit("SET_ADDRESS_LIST", response.data);

        window.$toast({
          color: "success",
          message: "Endereço removido!",
        });
      } catch (error) {
        console.log("[createOrUpdateAddress]", error);

        window.$toast({
          color: "error",
          message:
            "Tivemos um problema, tente novamente ou entre em contato conosco.",
        });
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async searchCardList({ commit }, data) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/payment/getCards`,
            {
              customer: { ...data },
              method: "pagarme5",
            }
          );

        commit("SET_CARD_LIST", response.data);
      } catch (error) {
        console.log("[searchCardList]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async removeCard({ commit }, data) {
      try {
        commit("SET_LOADING", true);

        const response = await window
          .$request()
          .post(
            `/${
              window.$platform || window.$getCookie("platform")
            }/payment/deleteCard`,
            {
              customer: { ...data.customer },
              method: "pagarme5",
              id: data.card_id,
            }
          );

        window.$toast({
          color: "success",
          message: "Cartão removido com sucesso!",
        });

        commit("SET_CARD_LIST", response.data);
      } catch (error) {
        console.log("[searchCardList]", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async searchAffiliateStatement({ commit }, { filters = {}, append } = {}) {
      // "Carregar mais" (append) usa o loading local do botão; as demais
      // cargas usam o overlay global, como nas outras páginas da conta.
      if (!append) commit("SET_LOADING", true);

      const body = {
        page: filters.page || 1,
        per_page: filters.per_page || 20,
      };
      if (filters.date_from) body.date_from = filters.date_from;
      if (filters.date_to) body.date_to = filters.date_to;
      if (filters.status) body.status = filters.status;

      const platform = window.$platform || window.$getCookie("platform");

      try {
        const { data } = await window
          .$request()
          .post(`/${platform}/affiliate/statement`, body);

        commit("SET_AFFILIATE", data.affiliate);
        commit("SET_AFFILIATE_BALANCE", data.balance);

        const tr = data.transactions || {
          data: [],
          current_page: 1,
          last_page: 1,
          total: 0,
        };
        commit(
          append
            ? "APPEND_AFFILIATE_TRANSACTIONS"
            : "SET_AFFILIATE_TRANSACTIONS",
          tr
        );
      } catch (error) {
        console.log("[searchAffiliateStatement]", error);
        throw error;
      } finally {
        if (!append) commit("SET_LOADING", false);
      }
    },

    async requestWithdrawal(_, payload) {
      const platform = window.$platform || window.$getCookie("platform");
      const { data } = await window
        .$request()
        .post(`/${platform}/affiliate/withdrawal`, payload);
      return data;
    },
  },
  modules: {},
};
